import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=dee804fc&"
import script from "./RequestList.vue?vue&type=script&lang=js&"
export * from "./RequestList.vue?vue&type=script&lang=js&"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=dee804fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports